import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    skin: PropTypes.oneOf([
        'standard',
        'cta'
    ])
};
const SecondaryTileName = createComponent({
    displayName: 'SecondaryTileName',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-secondary-tile-name'
            ]);
            if (props.skin === 'cta') classesSet.add('swan-secondary-tile-name-cta');
            return classesSet;
        }
    }
});

export { SecondaryTileName };
